(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["semio-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('semio-product-gallery')) {
    customElements.define('semio-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const choices = this.querySelectorAll('[data-gallery-choice]');
        const photos = this.querySelectorAll('[data-gallery-photo]');
        choices.forEach((choice) => choice.addEventListener('click', () => {
          photos.forEach((photo) => { photo.hidden = photo.dataset.galleryPhoto !== choice.dataset.galleryChoice; });
          choices.forEach((button) => button.setAttribute('aria-pressed', String(button === choice)));
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
